document.addEventListener('DOMContentLoaded', () => {
    // center first image on desktop */
    function centerFirstContainer() {
        let containers = [...document.getElementsByClassName('layout-scroll')[0].getElementsByClassName('container')];
        let firstContainer = containers[0];
        if(window.innerWidth > 768){            
            let marginLeft = ((window.innerWidth - firstContainer.getBoundingClientRect().width) / 2) - 40;
            if(marginLeft > 0) {
                firstContainer.style.marginLeft = marginLeft + "px";
            }
        } else {
            firstContainer.style.marginLeft = "0px";
        }
    }
    centerFirstContainer();
    window.addEventListener('resize', centerFirstContainer);    

  // Define the media query we want to check
  const MIN_WIDTH_QUERY = '(min-width: 769px)';

  // Store references to elements and variables that need to be accessible
  // across activate/deactivate calls.
  let container = null;
  let columns = [];
  let targetH2 = null;
  let targetP = null;
  let currentMiddleColumn = null; // Tracks the currently active middle column DOM element

  let scrollDebounceTimeout = null; // ID for the debounce timer
  let scrollEventHandler = null; // Store the actual event handler function for removal

  let isLogicActive = false; // Flag to indicate if the functionality is currently running

  /**
   * @function updateTargetContent
   * @description Updates the text content of the target H2 and P elements
   * with content from the provided source column. This function is defined
   * outside `activateScrollingLogic` so it can be called by it, but it
   * assumes `targetH2` and `targetP` are already defined from the outer scope.
   * @param {HTMLElement} sourceColumnElement - The column from which to extract content.
   */
  const updateTargetContent = (sourceColumnElement) => {
      // Ensure targets exist before attempting to update (though they should be checked in activateLogic)
      if (!targetH2 || !targetP) return;

      // Query for the H3 and P elements within the .content div of the source column
      const sourceH3 = sourceColumnElement.querySelector('.multicolumn-styles .content h3');
      const sourceP = sourceColumnElement.querySelector('.multicolumn-styles .content p');

      // Update the target H2 and P elements' textContent.
      // If a source element isn't found, its corresponding target will be cleared.
      targetH2.textContent = sourceH3 ? sourceH3.textContent : '';
      targetP.textContent = sourceP ? sourceP.textContent : '';
  };

  /**
   * @function updateMiddleColumnStatus
   * @description Determines which column is in the middle of the scrolling container.
   * Only updates the target content if a NEW middle column is found.
   * This function is defined outside `activateScrollingLogic` to be callable via debounce.
   */
  const updateMiddleColumnStatus = () => {
      // Ensure elements are still available (safety check if DOM changes)
      if (!container || !columns.length || !targetH2 || !targetP) return;

      const containerRect = container.getBoundingClientRect();
      const containerCenter = containerRect.left + containerRect.width / 2;
      const middleZoneTolerance = containerRect.width * 0.1; // Adjust 0.1 (10%) as needed
      const middleZoneLeft = containerCenter - middleZoneTolerance;
      const middleZoneRight = containerCenter + middleZoneTolerance;

      let potentialNewMiddleColumn = null;

      columns.forEach((column) => {
          const columnRect = column.getBoundingClientRect();
          const columnCenter = columnRect.left + columnRect.width / 2;

          const isInMiddle = (
              columnCenter >= middleZoneLeft &&
              columnCenter <= middleZoneRight &&
              columnRect.right > containerRect.left &&
              columnRect.left < containerRect.right
          );

          if (isInMiddle) {
              potentialNewMiddleColumn = column;
              if (!column.classList.contains('is-middle')) {
                  column.classList.add('is-middle');
              }
          } else {
              if (column.classList.contains('is-middle')) {
                  column.classList.remove('is-middle');
              }
          }
      });

      // ONLY update target content if a NEW middle column is found
      if (potentialNewMiddleColumn && potentialNewMiddleColumn !== currentMiddleColumn) {
          updateTargetContent(potentialNewMiddleColumn);
          currentMiddleColumn = potentialNewMiddleColumn;
      }
      // If no column is perfectly in the middle, or it's the same column,
      // the content remains unchanged.
  };

  /**
   * @function activateScrollingLogic
   * @description Initializes all event listeners and sets up the scrolling logic.
   * Only runs if the logic is not already active.
   */
  function activateScrollingLogic() {
      if (isLogicActive) return; // Prevent re-initialization

      console.log("Activating scrolling logic for min-width: 769px...");

      // Re-select elements on activation to ensure they are current
      container = document.querySelector('.page-bibliotheque .layout-scroll');
      columns = Array.from(container ? container.children : []); // Handle container being null
      targetH2 = document.querySelector('#bibliotheque-dynamic-content h2');
      targetP = document.querySelector('#bibliotheque-dynamic-content p');

      // Critical check: if any required elements are missing, do not activate.
      if (!container || !columns.length || !targetH2 || !targetP) {
          console.warn('Required elements for scrolling logic not found. Skipping activation.');
          return;
      }

      const DEBOUNCE_DELAY = 100;

      // Define the event handler function and store its reference
      scrollEventHandler = () => {
          clearTimeout(scrollDebounceTimeout);
          scrollDebounceTimeout = setTimeout(updateMiddleColumnStatus, DEBOUNCE_DELAY);
      };

      container.addEventListener('scroll', scrollEventHandler);

      // Perform an initial check to set content if a column is already in the middle
      updateMiddleColumnStatus();

      isLogicActive = true;
  }

  /**
   * @function deactivateScrollingLogic
   * @description Removes all event listeners and cleans up the DOM
   * when the media query no longer matches.
   */
  function deactivateScrollingLogic() {
      if (!isLogicActive) return; // Only deactivate if currently active

      console.log("Deactivating scrolling logic...");

      // Clear any pending debounce timeout
      if (scrollDebounceTimeout) {
          clearTimeout(scrollDebounceTimeout);
          scrollDebounceTimeout = null;
      }

      // Remove the scroll event listener if it was added
      if (container && scrollEventHandler) {
          container.removeEventListener('scroll', scrollEventHandler);
          scrollEventHandler = null; // Clear reference
      }

      // Clean up the DOM: clear displayed text and remove 'is-middle' classes
      if (targetH2) targetH2.textContent = '';
      if (targetP) targetP.textContent = '';

      // Remove 'is-middle' class from all columns
      if (columns && columns.length > 0) {
          columns.forEach(column => {
              column.classList.remove('is-middle');
          });
      }
      // Reset currentMiddleColumn tracking
      currentMiddleColumn = null;

      isLogicActive = false;
  }

  // --- Media Query Listener Setup ---
  const mediaQueryList = window.matchMedia(MIN_WIDTH_QUERY);

  /**
   * @function handleMediaQueryChange
   * @description Callback for media query changes. Activates/deactivates logic.
   * @param {MediaQueryListEvent} e - The event object from matchMedia.
   */
  function handleMediaQueryChange(e) {
      if (e.matches) {
          // Media query matches (min-width is 769px or more)
          activateScrollingLogic();
      } else {
          // Media query does NOT match (min-width is less than 769px)
          deactivateScrollingLogic();
      }
  }

  // --- Initial Check and Event Listener Attachment ---
  // Perform an initial check when the DOM is ready to set up the logic
  // based on the current window size.
  handleMediaQueryChange(mediaQueryList);

  // Listen for changes in the media query state (e.g., window resize)
  mediaQueryList.addEventListener('change', handleMediaQueryChange);

}); // End of DOMContentLoaded listener